var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNoteBlank = function SvgIconNoteBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.764 21.175a1 1 0 0 0 .851-.851l4.709-4.709a1 1 0 0 0 .85-.85l.076-.076V4.5a1.75 1.75 0 0 0-1.75-1.75h-15A1.75 1.75 0 0 0 2.75 4.5v15a1.75 1.75 0 0 0 1.75 1.75h10.19zM4.75 19.25V4.75h14.5v8.875h-4.625a1 1 0 0 0-1 1v4.625zm13.46-3.625-2.585 2.586v-2.586z",
    clipRule: "evenodd"
  })));
};
export default SvgIconNoteBlank;